import { observer } from 'mobx-react-lite'
import { DeleteDocumentsDialog } from '@/features/documents/components/DocumentManagementTable/DeleteDocumentsDialog'
import { type DeleteDocumentsDialogViewModel } from './DeleteDocumentsDialogViewModel'

export interface DeleteDocumentsDialogContainerProps {
  vm: DeleteDocumentsDialogViewModel
}

export const DeleteDocumentsDialogContainer = observer(
  function DeleteDocumentsDialogContainer({
    vm,
  }: DeleteDocumentsDialogContainerProps) {
    return (
      <DeleteDocumentsDialog
        documentCount={vm.documentCount}
        showing={vm.modal.showing}
        isPending={vm.delete.pending}
        onConfirm={vm.delete}
        onDecline={vm.cancel}
        testId="delete-documents"
      />
    )
  },
)
